import { Navigate } from 'react-router'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * Колишня примусова зміна пароля водія. Екран прибрано (рішення замовника 2026-10-28): пароль
 * водію задає адмін. Адресу лишено, щоб старі збірки PWA й закладки вели на Головну, а не на 404.
 */
export const pageConfig: IPageConfig = {
    route: '/driver/change-password',
    key: 'Driver.ChangePassword',
    title: 'Кабінет водія',
    template: 'public',
}

const ChangePasswordPage = () => <Navigate to="/driver" replace />

export default ChangePasswordPage
